import request from '@/utils/request'

// 查询省份数据
export function getProvinceData() {
  return request({
    url: '/index/area/getProvinceList',
    method: 'get'
  })
}

// 根据省份CODE查询市级数据
export function getCityDataByProvinceCode(provinceCode) {
  return request({
    url: '/index/area/getCityList',
    method: 'get',
    params:{
      provinceCode
    }
  })
}

// 根据地市CODE查询区、县数据
export function getAreaDataByCityCode(cityCode) {
  return request({
    url: '/index/area/getAreaList',
    method: 'get',
    params:{
      cityCode
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/area.js